import CreateCandidateOfferForm from 'domain/recruiting/candidate/offercompensation/createupdate/Create/CreateCandidateOfferForm';
import UpdateCandidateOfferForm from 'domain/recruiting/candidate/offercompensation/createupdate/Update/UpdateCandidateOfferForm';
import OfferTimelineRecordLayout from './OfferTimelineRecordLayout';
import { CANDIDATE_TIMELINE_RECORDS_ALIAS, CREATE_CANDIDATE_OFFER } from 'domain/shared/candidate';

const useCandidateOfferItem = () => ({
  AddForm: CreateCandidateOfferForm,
  UpdateForm: UpdateCandidateOfferForm,
  isApplicable: (item: any) => item && (item.type === CANDIDATE_TIMELINE_RECORDS_ALIAS.OFFER || item.offerId),
  source: null,
  urlPostfix: 'offers',
  RecordLayout: OfferTimelineRecordLayout,
  name: 'Offer',
  permissionToCheck: CREATE_CANDIDATE_OFFER,
  hasFullData: true,
});

export default useCandidateOfferItem;
